import { useState, useEffect } from "react";
import { MapPin, ChevronDown } from "lucide-react";
import { authFetch } from "@/utils/authFetch";

const API = process.env.REACT_APP_BACKEND_URL;

export default function RecentAddressPicker({ onSelect }) {
  const [addresses, setAddresses] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    authFetch(`${API}/api/user/recent-addresses`, { credentials: "include" })
      .then((r) => r.ok ? r.json() : { addresses: [] })
      .then((d) => setAddresses(d.addresses || []))
      .catch(() => {});
  }, []);

  if (!addresses.length) return null;

  return (
    <div className="relative" data-testid="recent-address-picker">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 text-sm font-medium px-3 py-2 border-2 transition-all w-full"
        style={{ borderColor: 'var(--border-light)', backgroundColor: 'var(--bg-card)', color: 'var(--text-secondary)' }}
        data-testid="recent-address-toggle"
      >
        <MapPin className="w-4 h-4 text-[#D4A537]" />
        <span>Quick fill from recent job</span>
        <ChevronDown className={`w-4 h-4 ml-auto transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute z-20 w-full mt-1 border-2 max-h-56 overflow-y-auto"
          style={{ borderColor: 'var(--border-main)', backgroundColor: 'var(--bg-card)' }}>
          {addresses.map((a, i) => (
            <button
              key={i}
              type="button"
              data-testid={`recent-addr-${i}`}
              onClick={() => { onSelect(a); setOpen(false); }}
              className="w-full text-left px-3 py-2.5 text-sm border-b hover:bg-[#D4A537]/10 transition-colors flex items-center gap-3"
              style={{ borderColor: 'var(--border-light)', color: 'var(--text-primary)' }}
            >
              <MapPin className="w-3.5 h-3.5 text-[#D4A537] flex-shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="font-medium truncate">{a.address}</p>
                <p className="text-xs truncate" style={{ color: 'var(--text-muted)' }}>
                  {[a.postcode, a.client_name].filter(Boolean).join(" — ")}
                </p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
